/**
 * Campaign creation should only offer countries that some publisher account config can
 * actually serve. The backend treats a config with no supportedCountries as applying to
 * every country, so a single unscoped config opens the full country list.
 */
import type { CampaignConfigurationDto, Country } from 'src/store/generated/leela-api-generated';

const isUnscopedToCountries = (config: CampaignConfigurationDto): boolean =>
  !config.supportedCountries?.length;

export const deriveCountriesFromPublisherConfigs = (
  configs: readonly CampaignConfigurationDto[] | undefined,
  allCountries: readonly Country[],
): Country[] => {
  if (!configs?.length) return [];
  if (configs.some(isUnscopedToCountries)) return [...allCountries];

  const uniqueCountries = new Set(configs.flatMap(config => config.supportedCountries ?? []));
  return Array.from(uniqueCountries).sort();
};
